export default __webpack_public_path__ + "static/enrolment-hero-image-014bde0bc4f2f0b56971c981eb4a5f79.jpg";